var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[_c('div',{staticClass:"time-part d-flex align-items-center"},[(_vm.text)?_c('justfit-heading',{staticClass:"m-0 font-weight-heavy",attrs:{"level":3}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }